import { Middleware } from 'redux';
import { monitorInformationService } from '../services';
import { syncActiveCalls } from '../reducers';

export const monitorMiddleware: Middleware = (store) => (next) => (action) => {
  const result = next(action);

  if (
    monitorInformationService.endpoints.getMonitorInformation.matchFulfilled(
      action
    )
  ) {
    const sectors = action.payload;
    const callingSectors = sectors.filter(
      (sector: any) => sector.status === 'CALLING'
    );

    setTimeout(() => {
      store.dispatch(syncActiveCalls(callingSectors));
    }, 0);
  }

  return result;
};
